module.exports = __webpack_public_path__ + "asia-logo.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/asia-logo.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/asia-logo.png
// module chunks = 15